import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';

interface TableProps {
  isTotal?: boolean;
  align?: 'center' | 'right';
}

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const MainBody = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const Load = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  padding: 4rem;
  overflow-y: auto;

`;

export const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const Title = styled.h1`
  font-size: 2rem;
  color: ${styleSheet.colorMainDark};
`;

export const InputMonth = styled.input.attrs({
  type: 'month',
  max: 4,
  min: 4,
})`
  width: 200px;
  height: 30px;
  padding: 5px;
  border: 0;
  border-radius: 8px;
`;

export const TableColumnText = styled.span`
  font-size: 1.2rem;
  white-space: nowrap;
`;

export const TableDataText = styled.span`
  font-size: 1.1rem;
  white-space: nowrap;
`;

export const TableStyle = styled.table`
  border-collapse: collapse; // collapse
  width: 100%;
  margin-bottom: 2rem;
`;

export const THead = styled.thead`
  font-size: 1.6rem;
`;

export const Th = styled.th`
  border: 1px solid #ddd;
  padding: 8px;

  padding-top: 3px;
  padding-bottom: 3px;
  text-align: left;
  background-color: #334391;
  color: white;
`;

export const TBody = styled.tbody`
  font-size: 1.2rem;
`;

export const Tr = styled.tr`
  
`;

export const Td = styled.td<TableProps>`
  border: ${({ isTotal }) => isTotal ? '0' : '1px solid #ddd'};
  padding: 2px 8px;
  color: ${({ isTotal }) => isTotal ? styleSheet.titleLight : '#000'};
  text-align: ${({ align }) => align ? align : 'left'};
`;

